import React from "react";
import CatalogFilterCheckboxItem from "./CatalogFilterCheckboxItem";

function CatalogFilterCbItemGroup({
  filterItems,
  searchValueObj,
  filterId,
  onFilterCbClick,
  filtersSelectedArr,
  cbItemDetails,
}) {
  return (
    <>
      {searchValueObj && searchValueObj[filterId]
        ? filterItems
            ?.filter(
              (i) =>
                i?.name
                  ?.toString()
                  .toLowerCase()
                  .indexOf(searchValueObj[filterId].toLowerCase()) > -1
            )
            ?.map((item) => {
              return (
                <CatalogFilterCheckboxItem
                  key={item?.id}
                  onFilterCbClick={onFilterCbClick}
                  item={{ ...item, ...cbItemDetails }}
                  isApplied={filtersSelectedArr.indexOf(item?.url_slug) > -1}
                />
              );
            })
        : filterItems?.map((item) => {
            return (
              <CatalogFilterCheckboxItem
                key={item?.id}
                onFilterCbClick={onFilterCbClick}
                item={{ ...item, ...cbItemDetails }}
                isApplied={filtersSelectedArr.indexOf(item?.url_slug) > -1}
              />
            );
          })}
    </>
  );
}

export default CatalogFilterCbItemGroup;
